// @flow

import React, { PureComponent } from 'react';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import { bindActionCreators } from 'redux';
import ResponsiveImage from 'components/ResponsiveImage/ResponsiveImage';
import SearchBar from 'components/SearchBar/SearchBar';
import { doSearch, handleChange } from 'scenes/SearchResults/duck/duck';
import { getKeywords } from 'scenes/SearchResults/duck/selector';
import type { History } from 'type/type';
import { Map } from 'immutable';
import smartSearch from 'hoc/smartSearch/smartSearch';

import './Header.scss';
import image from './hero-img.jpg';
import thumbnail from './hero-img_tn.jpg';

type Props = {
  doSearch: () => void,
  keywords: string,
  handleChange: (value: string) => void,
  history: History,
  onNav: () => void
}
export class Header extends PureComponent<Props> {
  onSearch = () => {
    if (this.props.keywords.trim() !== '') {
      this.props.doSearch();
      this.props.onNav();
    }
  }

  handleChange = (value: string) => {
    this.props.handleChange(value);
  }

  render() {
    return (
      <div className="home-header">
        <ResponsiveImage src={image} thumbnail={thumbnail} aspectRatio="31.25%" />
        <SearchBar
          size="lg"
          onSearch={this.onSearch}
          handleChange={this.handleChange}
          keywordsValue={this.props.keywords} />
      </div>
    );
  }
}

const mapToState = (state: Map<*, *>) => ({
  keywords: getKeywords(state),
});
const mapDispatch = dispatch => bindActionCreators({ doSearch, handleChange }, dispatch);

export default smartSearch((connect(mapToState, mapDispatch)(Header)));
